module.exports = __webpack_public_path__ + "img/195.96696018.jpg";